import React from 'react';
import { Virtual } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { OVERLAYS_URL } from '../../../Settings';
import {
    availableLodging,
} from '../../Game/GamePlayerInfo';
import {
    getFactionTextureId,
    getFactionTextureUrl,
} from '../../TwoD/Common/TextureTools';

import '../../TwoD/Components/Controls/Actions/action-scroller.css';
import './ActionChoice.css';

const OVERLAY_ADD = OVERLAYS_URL
    + 'LodgingAddOverlay-1080x210.png';

// ActionChoice — verbatim port of LodgingActionJuice's pools
// sub-section (juice mode) and AddLodging2d / LodgingPoolSelector
// (add mode). Per-row anchor `<div id="pools">` with an `<img
// className="swiper-overlay">` over the Swiper.
//
// Purely presentational. The highlight-lodging-event dispatch
// lifecycle lives in LodgingActionWindow because it depends on
// soldRobots state owned by the window.
export function ActionChoice({
    gameData, mode, onPoolClick,
}) {
    const pools = (gameData && gameData.lodging_pool)
        ? availableLodging(gameData) : [];

    const handlePoolClick = (factionId) => {
        if (typeof onPoolClick === 'function') onPoolClick(factionId);
    };

    return (
        <div className={'action-choice-anchor '
                + 'action-choice--' + mode}
             id={'pools'}
             data-testid={'action-choice'}
             data-mode={mode}>
            <img src={OVERLAY_ADD}
                 alt={'action'}
                 data-testid={'action-choice-overlay'}
                 className={'swiper-overlay'}/>
            <Swiper slidesPerView={6}
                    spaceBetween={0}
                    modules={[Virtual]}
                    className={'action-scroller-swiper'}>
                {pools.map((factionId, index) => (
                    <SwiperSlide key={'pool-' + index}
                                 virtualIndex={index}>
                        <div className={'action-choice-pool'}
                             data-testid={'action-choice-pool'}
                             data-faction={factionId}
                             data-pool-index={index}
                             data-tname={factionId
                                 ? getFactionTextureId(factionId) : undefined}
                             onClick={() => handlePoolClick(factionId)}>
                            <img
                                src={getFactionTextureUrl(factionId)}
                                alt={'lodging'}/>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default ActionChoice;
